<bs-digital-token-summary
    *ngIf="vm$ | async as vm"
    [summaryMessage]="vm.message"
    [tokenType]="vm.token?.rewardTokenType"
    [tokenContext]="tokenContext"></bs-digital-token-summary>
